/* Brain2Canvas — PaintFX: graffiti spray-/paint-cursor that sits BEHIND content.
   • Spray-Nebel: langsam/verweilend = dichter Sprühnebel + nasser Kern; schnell = dünne Linie.
   • Auto-Kontrastfarben pro Section (gelber BG -> lila Paint, dunkel -> hell, hell -> tief …).
   • Liegt hinter klickbaren Inhalten (z-index:-1 + isolation), pausiert wenn unsichtbar/idle,
     respektiert prefers-reduced-motion.
   Nutzung: <script src="paintfx.js"></script> (auto auf einfarbigen Sections) ODER
            window.PaintFX(el, { bg:'#9da1ca', palette:['#fbe785','#0e0e10'], width:30, spray:14 }). */
(function () {
  function hexToRgb(h) {
    h = (h || '').trim().replace('#', '');
    if (h.length === 3) h = h.split('').map(function (c) { return c + c; }).join('');
    var n = parseInt(h, 16);
    if (isNaN(n)) return [14, 14, 16];
    return [(n >> 16) & 255, (n >> 8) & 255, n & 255];
  }
  function parseColor(str) { // -> [r,g,b,a] or null
    if (!str) return null;
    if (str[0] === '#') { var c = hexToRgb(str); return [c[0], c[1], c[2], 1]; }
    var m = str.match(/rgba?\(([^)]+)\)/i);
    if (!m) return null;
    var p = m[1].split(',').map(function (x) { return parseFloat(x); });
    return [p[0] | 0, p[1] | 0, p[2] | 0, p.length > 3 ? p[3] : 1];
  }
  function dist(a, b) { var dr = a[0]-b[0], dg = a[1]-b[1], db = a[2]-b[2]; return dr*dr+dg*dg+db*db; }

  // brand backgrounds -> curated contrasting palette
  var THEMES = [
    { bg: [14,14,16],    pal: ['#fbe785','#9da1ca','#ecd9de','#ffffff'] }, // ink  -> bright
    { bg: [251,231,133], pal: ['#8086c6','#5f67a6','#0e0e10','#ecd9de'] }, // yellow -> purple/ink
    { bg: [157,161,202], pal: ['#fbe785','#0e0e10','#ffffff','#ecd9de'] }, // peri -> yellow/ink
    { bg: [128,134,198], pal: ['#fbe785','#0e0e10','#ffffff','#ecd9de'] }, // peri2
    { bg: [236,217,222], pal: ['#8086c6','#5f67a6','#0e0e10','#fbe785'] }, // mauve -> purple/ink
    { bg: [243,241,233], pal: ['#8086c6','#5f67a6','#0e0e10','#fbe785'] }, // paper -> purple/ink
    { bg: [255,255,255], pal: ['#8086c6','#5f67a6','#0e0e10','#fbe785'] }  // white
  ];
  function autoPalette(rgb) {
    var best = THEMES[0], bd = Infinity;
    for (var i = 0; i < THEMES.length; i++) { var d = dist(rgb, THEMES[i].bg); if (d < bd) { bd = d; best = THEMES[i]; } }
    return best.pal;
  }

  function PaintFX(el, opts) {
    opts = opts || {};
    if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (!el || el.querySelector('.paintfx')) return;

    var cs = getComputedStyle(el);
    var bgRGBA = parseColor(opts.bg) || parseColor(cs.backgroundColor) || [14,14,16,1];
    var bg = [bgRGBA[0], bgRGBA[1], bgRGBA[2]];
    var pal = (opts.palette && opts.palette.length ? opts.palette : autoPalette(bg))
      .map(function (c) { return Array.isArray(c) ? c : hexToRgb(c); });

    var MAXW = opts.width || 30, MINW = opts.minWidth || 6, HEAL = opts.heal || 0.05, DRIFT = opts.drift || 0.028, SPRAY = opts.spray || 14;

    if (cs.position === 'static') el.style.position = 'relative';
    el.style.isolation = 'isolate';
    if (cs.overflow === 'visible') el.style.overflow = 'hidden';

    var canvas = document.createElement('canvas');
    canvas.className = 'paintfx'; canvas.setAttribute('aria-hidden', 'true');
    canvas.style.cssText = 'position:absolute;inset:0;width:100%;height:100%;z-index:-1;pointer-events:none;display:block';
    el.insertBefore(canvas, el.firstChild);

    var ctx = canvas.getContext('2d'), dpr = Math.min(window.devicePixelRatio || 1, 2), W = 0, H = 0;
    function resize() {
      var r = el.getBoundingClientRect();
      W = Math.max(1, Math.round(r.width)); H = Math.max(1, Math.round(r.height));
      canvas.width = Math.round(W * dpr); canvas.height = Math.round(H * dpr);
      canvas.style.width = W + 'px'; canvas.style.height = H + 'px';
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    }
    resize();
    if ('ResizeObserver' in window) new ResizeObserver(resize).observe(el);
    else addEventListener('resize', resize, { passive: true });

    var BG = 'rgba(' + bg[0] + ',' + bg[1] + ',' + bg[2] + ',';
    function colorAt(p) {
      var n = pal.length, i = ((Math.floor(p) % n) + n) % n, j = (i + 1) % n, f = p - Math.floor(p);
      var a = pal[i], b = pal[j];
      return [Math.round(a[0]+(b[0]-a[0])*f), Math.round(a[1]+(b[1]-a[1])*f), Math.round(a[2]+(b[2]-a[2])*f)];
    }

    var target = null, brush = null, prev = null, phase = 0, idle = 0;
    function onMove(e) {
      var r = canvas.getBoundingClientRect();
      target = { x: e.clientX - r.left, y: e.clientY - r.top };
      if (!brush) { brush = { x: target.x, y: target.y }; prev = { x: target.x, y: target.y }; }
      idle = 0; start();
    }
    el.addEventListener('pointermove', onMove, { passive: true });
    el.addEventListener('pointerleave', function () { target = null; brush = null; });

    var running = false, visible = true, raf = 0, sdrips = [];
    function frame() {
      ctx.globalCompositeOperation = 'source-over'; ctx.globalAlpha = 1;
      ctx.fillStyle = BG + HEAL + ')'; ctx.fillRect(0, 0, W, H);
      // Drips, die beim Verweilen entstehen, laufen ein Stück runter (heilen dann mit weg)
      for (var di = sdrips.length - 1; di >= 0; di--) {
        var d = sdrips[di], ny = d.y + d.vy;
        ctx.strokeStyle = 'rgba(' + d.col + ',0.5)'; ctx.lineWidth = d.w; ctx.lineCap = 'round';
        ctx.beginPath(); ctx.moveTo(d.x, d.y); ctx.lineTo(d.x, ny); ctx.stroke();
        d.y = ny; d.vy = Math.min(1.8, d.vy + 0.04); d.life += d.vy;
        if (d.life >= d.max) sdrips.splice(di, 1);
      }
      if (brush && target) {
        prev = { x: brush.x, y: brush.y };
        brush.x += (target.x - brush.x) * 0.2;
        brush.y += (target.y - brush.y) * 0.2;
        var dx = brush.x - prev.x, dy = brush.y - prev.y, sp = Math.sqrt(dx*dx + dy*dy);
        var w = Math.max(MINW, MAXW - sp * 0.95);          // slow = fat, fast = thin
        var slow = 1 - w / MAXW;                            // 0 fast .. ~1 dwelling (actually inverse)
        var fastness = sp / (MAXW);                         // for line visibility on quick moves
        phase += DRIFT + sp * 0.0026;
        var c = colorAt(phase), rgb = c[0] + ',' + c[1] + ',' + c[2];

        // nasser Kern — stärker beim Verweilen
        var coreA = Math.min(0.26, Math.max(0.04, (w / MAXW) * 0.28));
        var g = ctx.createRadialGradient(brush.x, brush.y, 0, brush.x, brush.y, w);
        g.addColorStop(0, 'rgba(' + rgb + ',' + coreA + ')');
        g.addColorStop(1, 'rgba(' + rgb + ',0)');
        ctx.fillStyle = g; ctx.beginPath(); ctx.arc(brush.x, brush.y, w, 0, 6.283); ctx.fill();

        // dünne Verbindungslinie (damit schnelle Striche lesbar bleiben)
        ctx.strokeStyle = 'rgba(' + rgb + ',' + (0.08 + Math.min(0.3, fastness * 0.5)) + ')';
        ctx.lineWidth = Math.max(1.4, w * 0.42); ctx.lineCap = 'round'; ctx.lineJoin = 'round';
        ctx.beginPath(); ctx.moveTo(prev.x, prev.y); ctx.lineTo(brush.x, brush.y); ctx.stroke();

        // Sprühnebel — breiter & dichter beim Verweilen
        var spread = Math.max(4, w * 1.35);
        for (var k = 0; k < SPRAY; k++) {
          var ang = Math.random() * 6.283, rr = Math.pow(Math.random(), 0.7) * spread;
          var sx = brush.x + Math.cos(ang) * rr, sy = brush.y + Math.sin(ang) * rr;
          var pr = Math.random() * 1.5 + 0.5;
          ctx.fillStyle = 'rgba(' + rgb + ',' + (0.05 + Math.random() * 0.15) + ')';
          ctx.beginPath(); ctx.arc(sx, sy, pr, 0, 6.283); ctx.fill();
        }
        // Drip nur wenn langsam/verweilend
        if (sp < 1.0 && w > MAXW * 0.62 && Math.random() < 0.1)
          sdrips.push({ x: brush.x, y: brush.y + w * 0.5, vy: 0.3, w: Math.max(1.4, w * 0.16), col: rgb, life: 0, max: 16 + Math.random() * 42 });
        idle = 0;
      } else {
        idle++;
      }
      if ((idle > 130 && !sdrips.length) || !visible) { stop(); return; } // settle, then sleep to save CPU
      raf = requestAnimationFrame(frame);
    }
    function start() { if (!running && visible) { running = true; idle = 0; raf = requestAnimationFrame(frame); } }
    function stop() { running = false; cancelAnimationFrame(raf); }

    if ('IntersectionObserver' in window)
      new IntersectionObserver(function (es) { es.forEach(function (en) { visible = en.isIntersecting; if (visible) start(); else stop(); }); }, { threshold: 0.02 }).observe(el);
    else start();
  }

  window.PaintFX = PaintFX;

  // ---- auto-apply on solid-colour sections (everywhere, subtle, behind content) ----
  function eligible(el) {
    if (el.hasAttribute('data-paintfx-skip')) return false;
    if (el.querySelector('.paintfx')) return false;
    var cs = getComputedStyle(el);
    if (cs.backgroundImage && cs.backgroundImage !== 'none') return false; // skip image/gradient bg
    var col = parseColor(cs.backgroundColor);
    if (!col || col[3] < 0.92) return false;                                // need an opaque own bg
    var r = el.getBoundingClientRect();
    if (r.width < 220 || r.height < 170) return false;                      // skip thin bars/marquees
    if (el.querySelector('.collage, canvas.meshbg, .marq')) return false;   // skip decorative heroes
    return true;
  }
  function auto() {
    document.querySelectorAll('[data-paintfx]').forEach(function (el) {
      PaintFX(el, {
        bg: el.getAttribute('data-paint-bg') || undefined,
        palette: (el.getAttribute('data-paint-colors') || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean),
        width: parseFloat(el.getAttribute('data-paint-width')) || undefined,
        spray: parseFloat(el.getAttribute('data-paint-spray')) || undefined
      });
    });
    document.querySelectorAll('section, footer.ftr, .formsec, .art-rel').forEach(function (el) {
      if (!el.hasAttribute('data-paintfx') && eligible(el)) PaintFX(el, {});
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', auto);
  else auto();
})();
